import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';

import { exportModal as TEXT } from 'locales/en';
import ModalWithChildren from 'components/ModalWithChildren';
import ButtonWithIcon from 'components/ButtonWithIcon';

const ExportModal = ({
  _isOpen,
  onConfirm,
  buttonTitle,
  title,
  buttonClass,
  icon,
  isDisabled,
}) => {
  const [isOpen, setIsOpen] = useState(_isOpen);
  const [isLoading, setIsLoading] = useState(false);
  const email = useSelector((state) => state.auth.user.email);

  const _onConfirm = async (e) => {
    e.preventDefault();
    if (onConfirm) {
      setIsLoading(true);
      await onConfirm();
      setIsLoading(false);
      setIsOpen(false);
    }
  };

  const onCancel = () => {
    setIsOpen(false);
  };

  return (
    <>
      <ButtonWithIcon
        className={buttonClass}
        title={buttonTitle}
        onClick={() => setIsOpen(true)}
        icon={icon}
        isDisabled={isDisabled}
      />
      <ModalWithChildren
        isOpen={isOpen}
        header={title}
        isLoading={isLoading}
        ctaTitle={isLoading ? TEXT.exporting : TEXT.export}
        onClickCta={_onConfirm}
        cta2Title={TEXT.cancel}
        onClickCta2={onCancel}
        className="bg-gray-50"
        headerClassName="p-12"
      >
        <>
          <div className="mt-12">
            <div>
              <FontAwesomeIcon icon="info-circle" />
              <span className="ml-2 text-sm text-javelin-gray-dark">
                {TEXT.message}
              </span>
            </div>
          </div>
          <div className="relative">
            <input
              className={`input input-full-border py-3 px-4 border-javelin-gray-border border mt-7`}
              disabled
              placeholder="Enter your email address"
              value={email}
            />
          </div>
        </>
      </ModalWithChildren>
    </>
  );
};

ExportModal.propTypes = {
  buttonTitle: PropTypes.string,
  title: PropTypes.string,
  buttonClass: PropTypes.string,
  onConfirm: PropTypes.func,
  isDisabled: PropTypes.bool,
};
ExportModal.defaultProps = {
  _isOpen: false,
  buttonTitle: 'Export',
  title: 'Export',
  isDisabled: false,
};

export default ExportModal;
